









import { Vue, Prop, Component } from "vue-property-decorator"
import Conversion from "@/components/BaseComponents/Conversion.vue"

@Component({
	components: {
		Conversion
	}
})
export default class CreateRecipeProcedure extends Vue {
	@Prop({ required: true }) combinations!: ConversionObject;
}
